module.exports = __webpack_public_path__ + "static/img/building.a14de20.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/about/imgs/building.png
// module id = w/Kr
// module chunks = 1